module.exports = __webpack_public_path__ + "static/painting-brothers-754af54aef19a370ec2f7914580210db.jpg";